import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 34.02 34.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.02 34.02\" id=\"icon-download\"><title>icon_画板</title><path d=\"M17,22.24h-.16A1,1,0,0,1,16.3,22l-.08-.06L8.28,14.49a1.14,1.14,0,0,1,1.56-1.66l6,5.64V6.07a1.14,1.14,0,0,1,2.28,0v12.4l6-5.63a1.15,1.15,0,0,1,1.62.06,1.17,1.17,0,0,1,.31.78,1.14,1.14,0,0,1-.37.83l-7.94,7.43h0a1.19,1.19,0,0,1-.71.3H17Z\" /><path d=\"M26.41,29.09H7.61a1.15,1.15,0,0,1,0-2.29h18.8a1.15,1.15,0,0,1,0,2.29Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol